import { render, staticRenderFns } from "./EdForm.vue?vue&type=template&id=625d0419&scoped=true&"
import script from "./EdForm.vue?vue&type=script&lang=js&"
export * from "./EdForm.vue?vue&type=script&lang=js&"
import style0 from "./EdForm.vue?vue&type=style&index=0&id=625d0419&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625d0419",
  null
  
)

export default component.exports